import { render, staticRenderFns } from "./Changelog.vue?vue&type=template&id=170a5d9e&scoped=true&lang=pug&"
var script = {}
import style0 from "./Changelog.vue?vue&type=style&index=0&id=170a5d9e&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "170a5d9e",
  null
  
)

export default component.exports